import type { Skill, Faction } from '~/types/game';

export const skills: Skill[] = [
  { name: 'INTRUSION',   lv: 14, max: 20, tone: 'action' },
  { name: 'STEALTH',     lv: 9,  max: 20, tone: 'data' },
  { name: 'HARDWARE',    lv: 11, max: 20, tone: 'data' },
  { name: 'SOCIAL ENG',  lv: 6,  max: 20, tone: 'warn' },
  { name: 'COUNTER-ICE', lv: 12, max: 20, tone: 'hostile' },
];

export const factions: Faction[] = [
  { name: 'SAGINAW CIRCLE',  rel: 72, side: 'ally' },
  { name: 'NIGHTCREST CORP', rel: 18, side: 'enemy' },
  { name: 'COURIER LATTICE', rel: 54, side: 'neutral' },
  { name: 'K-2 RELAY OPS',   rel: 41, side: 'neutral' },
];
